import React from "react";
import Styles from "./WorkspaceLoading.module.css";

// the only role of this component is to prevent showing dashboard when user is loading workspace from the url
export const WorkspaceLoading = () => (
  <div className={Styles.workspaceLoading} />
);
